export default function Favourties() {

    return (
      <div className="favourites-page-content">
          <h1>Favourites</h1>
      </div>
    );
  }
  